import React from 'react';

import type { MenuSection, SectionId } from '../types';

interface SidebarMenuProps {
  menuSections: MenuSection[];
  activeSection: SectionId;
  onToggleSection: (sectionId: string) => void;
  onSelectSection: (sectionId: SectionId) => void;
}

function SidebarMenu({ menuSections, activeSection, onToggleSection, onSelectSection }: SidebarMenuProps) {
  return (
    <div
      className="mr-4 hidden overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-md xl:block"
      style={{ width: '320px', position: 'sticky', top: '20px', height: 'calc(100vh - 260px)' }}
    >
      <div
        className="rounded-t-2xl py-4 text-center font-semibold text-white"
        style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)' }}
      >
        <span role="img" aria-label="books">📚</span> SOMMAIRE
      </div>

      {menuSections.map((section) => (
        <div key={section.id} className="border-b border-slate-200">
          <button
            type="button"
            onClick={() => onToggleSection(section.id)}
            className={[
              'w-full text-left px-5 py-3 font-bold flex items-center justify-between',
              section.expanded ? 'text-white' : 'text-emerald-700',
            ].join(' ')}
            style={{ background: section.expanded ? 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)' : '#f8fafc' }}
          >
            <span>
              <span dangerouslySetInnerHTML={{ __html: section.emoji }} /> {section.title}
            </span>
            <span className="text-xs" style={{ transform: section.expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>{section.icon}</span>
          </button>
          {section.expanded && (
            <div className="bg-slate-50">
              {section.items.map((item) => (
                <button
                  type="button"
                  key={item.id}
                  onClick={() => onSelectSection(item.id)}
                  className={[
                    'w-full text-left px-6 py-3 text-sm',
                    activeSection === item.id ? 'border-l-4 border-emerald-600 bg-emerald-50 text-emerald-800 font-semibold' : 'text-slate-600',
                  ].join(' ')}
                >
                  <span dangerouslySetInnerHTML={{ __html: item.emoji }} /> {item.title}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default SidebarMenu;


